import React, { useEffect } from 'react'
import Loader from '../../layout/Loader'
import toast from 'react-hot-toast';
import {MDBDataTable} from 'mdbreact';
import {Link, useNavigate, useSearchParams} from "react-router-dom";
import MetaData from '../../layout/MetaData'
import {useDispatch} from 'react-redux';
import '../../../css/Driver.css'
import {useMyOrdersDriverQuery} from '../../../redux/api/driverApi'

const DriverMyBookings = () => {

      const {data, isLoading, error} = useMyOrdersDriverQuery();
       
          const [searchParams] = useSearchParams()
          const navigate = useNavigate()
      
          const orderSuccess = searchParams.get("order_success")
      
          useEffect(() => {
              if(error){
                toast.error(error?.data?.message)
              }
          
            }, [error, orderSuccess]);
        
            const setOrders = () => {
              const orders = {
                  columns: [
                      // {
                      //     label: 'Amount Paid',
                      //     field: 'amount',
                      //     sort: "asc",
                      // },
                      {
                          label: 'Date',
                          field: 'createdAt',
                          sort: "asc",
                      },
                      {
                          label: 'View',
                          field: 'actions',
                          sort: "asc",
                      },
                  ],
                  rows: [],
              };
      
              data?.orders?.forEach((order) => {
                  orders.rows.push({
                      // amount: `PKR ${order?.totalAmount}`,
                      createdAt: order?.createdAt?.split('T')[0],
                      actions: (
                      <> 
                      <Link to={`/driver/bookings/${order?._id}`} className="btn btn-primary" id='order-view-admin-orders'> 
                      <i className="fa fa-eye" id='order-view-logo'></i>
                      </Link>
      
                      </>
                  ),
                  });
              });
      
              return orders
            }
      
            if(isLoading) return <Loader />;

  return (
    <> 
    <MetaData title ={'My Bookings'} />
    <div>
    <h1 className='my-5'>  اپ نےاج تک  {data?.orders?.length || 0} بکنگز کی</h1>

    <MDBDataTable 
    data={setOrders()}
    className='px-3'
    id='user-orders-id'
    bordered
    striped
    hover
    />
    </div>

</>
  )
}

export default DriverMyBookings
